export default function AutomationLevels() {
  const levels = [
    {
      level: 'Lv1',
      title: '半自動',
      target: '月商100万ゾーン',
      color: 'from-blue-500 to-blue-600',
      items: ['利益計算', '出品CSV', '在庫同期']
    },
    {
      level: 'Lv2',
      title: '全自動',
      target: '月商500万ゾーン',
      color: 'from-primary to-primary-dark',
      items: ['価格改定', '仕入れ判定', '広告調整']
    },
    {
      level: 'Lv3',
      title: '無人',
      target: '月商1000万超ゾーン',
      color: 'from-purple-600 to-purple-700',
      items: ['AI商品抽出', '自動発注', '自動広告', '自動撤退']
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-gray-900 mb-6">
            レベル別 <strong className="text-primary">自動化段階</strong>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {levels.map((level, index) => (
            <div key={index} className="bg-white border-2 border-gray-200 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className={`bg-gradient-to-br ${level.color} text-white p-8 text-center`}>
                <div className="text-5xl font-black mb-2">{level.level}</div>
                <div className="text-2xl font-bold mb-4">{level.title}</div>
                <div className="bg-white/20 rounded-lg px-4 py-2 inline-block">
                  <div className="text-sm font-medium">→ {level.target}</div>
                </div>
              </div>
              
              <div className="p-8">
                <ul className="space-y-4">
                  {level.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-center gap-3">
                      <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-primary"></i>
                      </div>
                      <span className="text-gray-700 font-medium">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
